import React, { useState, useEffect } from 'react';

const testimonials = [
  {
    text: "This bundle saved me months of work and made us investor-ready!",
    author: "- Arun Singh, IT Startup CEO"
  },
  {
    text: "This bundle has empowered my team and me to unlock its full potential for our success!",
    author: "- Nirbhay Kundan, Co-Founder, E-Commerce Startup"
  },
  {
    text: "My team and I are fully leveraging this bundle to drive our business forward!",
    author: "- Hemant Pathak, Owner, Startup Factory"
  }
];

function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="mt-12 bg-gray-100 py-10 px-6 rounded-lg shadow-md max-w-4xl mx-auto text-center">
      <h2 className='text-yellow-500 text-2xl font-bold mb-6'>What Founders Say</h2>
      <div className="p-6">
        <p className="text-lg text-gray-800 italic">{testimonials[index].text}</p>
        <p className="font-bold text-gray-900 mt-2">{testimonials[index].author}</p>
      </div>
      <div className="flex justify-center mt-4 space-x-2">
        {testimonials.map((_, i) => (
          <span
            key={i}
            className={`h-3 w-3 rounded-full transition-all duration-300 ${i === index ? 'bg-yellow-500' : 'bg-gray-300'}`}
          ></span>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
